import Vue from 'vue'
import VueTouch from 'vue-touch'
import VModal from 'vue-js-modal'
import moment from 'moment'
import { ValidationObserver, ValidationProvider, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import { required, numeric, email, min, max, confirmed } from 'vee-validate/dist/rules'
import viewportUnitsBuggyfill from 'viewport-units-buggyfill'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'

import * as mdbvue from 'mdbvue'
for (const component in mdbvue) {
  Vue.component(component, mdbvue[component])
}

Vue.use(VModal, { componentName: 'v-modal' })

viewportUnitsBuggyfill.init({ force: true });

VueTouch.config.swipe = {
  direction: 'horizontal'
}
Vue.use(VueTouch, { name: 'v-touch' })

const atoms = require.context('@/components/atoms', true, /\.vue$/)
const atomsComponents = {}
atoms.keys().forEach(key => {
  atomsComponents[key.replace(/(\.\/|\.vue)/g, '')] = atoms(key).default
})

Object.keys(atomsComponents).forEach(key => {
  Vue.component(key, atomsComponents[key])
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('required', { ...required })
extend('numeric', { ...numeric })
extend('email', { ...email })
extend('min', { ...min })
extend('max', { ...max })
extend('confirmed', { ...confirmed })

localize('ja', ja)

import Notify from 'mdbvue/src/components/pro/Advanced/Notify'
Vue.use(Notify)

Vue.filter('moment', function (value, format) {
  if (!value) return ''
  moment.locale('ja')
  return moment(value).format(format)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
